import { FundraisingReqRes } from '../fundraising/fundraisings-tab/FundraisingReqRes.model';
import { GpHolding } from 'src/app/dashboard/shared/holding/GpHolding.model';

export class UpdateHoldingStatusDialogContext {
  constructor(
    public holding: GpHolding,
    public fundraising: FundraisingReqRes) { }
}
